import { FEATURES } from '@/src/constants/Text'

export const MENSAGEM_INCONCLUSIVO = {
  mensagem:
    'Inconclusivo é a diferença do que temos na DRE global versus o que temos de detalhamento por profissional/filial/produto. Valores sem detalhamento nas planilhas de suporte (ex.: planilha de comissionamento)',
}

export const filterRoutes = (listRoutes, user) => {
  const validation = listRoutes.filter((option) => {
    const validationUser = option.permission.some((p) => {
      return p === 'all' || user[p]
    })

    return validationUser && option.permissionsFlags
  })

  return validation
}

export const financeOptionsRoutes = (showFeatures, user) => {
  const routes = [
    {
      name: 'finance.overview',
      title: 'Visão Geral',
      subtitle: 'Acompanhe o resultado consolidado do escritório',
      permission: ['IS_GESTOR'],
      // not have flag to validation true is default
      permissionsFlags: true,
    },
    {
      name: 'finance.dre',
      title: 'Demonstrativos (DRE+DFC)',
      subtitle: 'Demonstrativo de resultados e fluxo de caixa',
      permission: ['IS_GESTOR', 'leader'],
      permissionsFlags: showFeatures[FEATURES.P_L_PJ],
    },
    {
      name: 'finance.professional',
      title: 'Profissional',
      subtitle: 'Resultado financeiro por profissional',
      permission: ['all'],
      permissionsFlags: showFeatures[FEATURES.P_L_PROFISSIONAL],
    },
    {
      name: 'finance.product',
      title: 'Produto',
      subtitle: 'Resultado financeiro por área de receita',
      permission: ['IS_GESTOR', 'HAS_AREA', 'leader'],
      permissionsFlags: showFeatures[FEATURES.P_L_AREA_DE_RECEITA],
    },
    {
      name: 'finance.filial',
      title: 'Filial',
      subtitle: 'Resultado financeiro por filial',
      permission: ['IS_GESTOR', 'HAS_SUBSIDIARIES', 'leader'],
      permissionsFlags: showFeatures[FEATURES.P_L_FILIAL],
    },
    {
      name: 'finance.team',
      title: 'Equipe',
      subtitle: 'Resultado financeiro por equipe',
      permission: ['IS_GESTOR', 'leader'],
      permissionsFlags: showFeatures[FEATURES.P_L_EQUIPE],
    },
    {
      name: 'finance.comparative',
      title: 'Comparativo',
      subtitle: 'Compare períodos e versões da DRE',
      permission: ['IS_GESTOR', 'leader'],
      // not have flag to validation true is default
      permissionsFlags: true,
    },
    {
      name: 'finance.orcado_realizado',
      slug: 'orcado_realizado',
      title: 'Orçado vs realizado',
      subtitle: 'Acompanhe o orçado frente ao realizado',
      permission: ['IS_GESTOR'],
      permissionsFlags: showFeatures[FEATURES.ORCADO_REALIZADO],
    },
  ]

  const filterAccess = filterRoutes(routes, user)

  return filterAccess
}
